module.exports = __webpack_public_path__ + "img/20210625_Teilkauf_2897.b95c0c87.webp";